import * as React from 'react';

import { DataTable, Table } from '../../components/common';
import { IconButton } from '../../components/buttons';
import { IconEdit } from '../../components/icons';
import Utils from '../../common/utils';

interface Props {
	notes: CustomerNote[];
	history: any;
	match: any;
	hasStripeId: boolean;
}
interface State {
	page: number;
}
class CustomerNotesList extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			page: 0
		};
	}

	onPageChange = (pageIndex: number) => {
		this.setState({ page: pageIndex });
	}

	render() {
		const { ...props } = this.props;
		return (
			<DataTable
				TableComponent={p => <Table isDataTable={true}>{p.children}</Table>}
				columns={[
					{
						accessor: 'id',
						show: false
					},
					{
						Header: 'Date',
						accessor: 'createdDate',
						maxWidth: 200,
						Cell: (rowInfo: any) => Utils.formatDate(rowInfo.value)
					},
					{
						Header: 'Last Modified By',
						accessor: 'changedBy'
					},
					{
						Header: 'Question Category',
						accessor: 'answerInfo'
					},
					{
						Header: 'Notes',
						accessor: 'notes',
						getProps: (state: any, rowInfo: any, column: any) => {
							return {
								style: {
									whiteSpace: 'normal'
								}
							};
						}
					},
					{
						Header: 'Actions',
						className: 'p-0 td-actions',
						width: 100,
						Cell: (rowInfo: any) => {
							return (
								<IconButton
									title="Edit note"
									className="btn-icon-secondary btn-icon-td"
									onClick={(e: any) => {
										e.stopPropagation(); // Prevent onClick conflict with tr onclick
										if (window.location.href.includes('prospects')) {
											return props.history.push(`/admin/prospects/${rowInfo.original.customerId}/notes/${rowInfo.original.id}`);
										} else {
											return props.history.push(`/admin/customers/${rowInfo.original.customerId}/notes/${rowInfo.original.id}`);
										}
									}}
								>
									<IconEdit />
								</IconButton>
							);
						}
					}
				]}
				data={props.notes}
				getTrProps={(state: any, rowInfo: any, column: any) => {
					return {
						className: 'tr interactive',
						onClick: (e: any) => {
							if (window.location.href.includes('prospects')) {
								return props.history.push(`/admin/prospects/${rowInfo.original.customerId}/notes/${rowInfo.original.id}`);
							} else {
								return props.history.push(`/admin/customers/${rowInfo.original.customerId}/notes/${rowInfo.original.id}`);
							}
						}
					};
				}}
				noDataText="No notes found"
				onPageChange={this.onPageChange}
				page={this.state.page}
			/>
		);
	}
}
export default CustomerNotesList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/CustomerNotesList.tsx